export default [
  {
    name: 'getEditPageConfigInfo',
    method: 'POST',
    path: '/PF/PageEdit/GetEditPageConfigInfo',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取编辑表单配置信息'
  }
]